import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Eye, Loader2, Send } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { esignAPI, errMsg } from '../../lib/esignAPI';

const money = (v) => `$${Number(v || 0).toFixed(2)}`;

export const SendConfirmDialog = ({ clientId, body, open, onClose, onSent }) => {
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setP(null);
    esignAPI.sendPreview(clientId, body).then(setP).catch((e) => { toast.error(errMsg(e)); onClose(); });
  }, [open]); // eslint-disable-line
  const pdf = async () => { try { window.open(URL.createObjectURL(await esignAPI.sendPreviewBlob(clientId, body)), '_blank', 'noopener'); } catch (e) { toast.error(errMsg(e)); } };
  const send = async () => {
    setBusy(true);
    try { await esignAPI.send(clientId, body); toast.success('Engagement letter sent for signature'); onSent(); onClose(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="esign-send-confirm">
        <DialogHeader><DialogTitle>Send engagement letter for signature?</DialogTitle></DialogHeader>
        {!p ? <div className="flex justify-center py-8"><Loader2 className="h-6 w-6 animate-spin" /></div> : (
          <div className="space-y-4 text-sm">
            <div data-testid="esign-confirm-template"><p className="text-xs uppercase text-muted-foreground">Template</p>{p.template.name} <span className="text-xs text-muted-foreground">({p.template.version})</span></div>
            <div data-testid="esign-confirm-services"><p className="text-xs uppercase text-muted-foreground">Services included</p>
              {p.services.map((s, i) => <div key={i} className="flex justify-between"><span>{s.name}</span><span>{money(s.total)}</span></div>)}
              <div className="mt-1 flex justify-between border-t pt-1 font-medium"><span>Total payable</span><span>{money(p.fee_summary.total)}</span></div></div>
            <div data-testid="esign-confirm-signers"><p className="text-xs uppercase text-muted-foreground">Signatories {p.sequential ? '(sign in this order)' : '(any order)'}</p>
              {p.signers.map((s) => <div key={s.signing_order}>{s.signing_order}. {s.name} – {s.capacity} &lt;{s.email}&gt;</div>)}</div>
            <div data-testid="esign-confirm-notify"><p className="text-xs uppercase text-muted-foreground">This will email/notify</p>
              <ul className="list-disc pl-5">{p.notify.map((n) => <li key={n}>{n}</li>)}</ul></div>
            <Button variant="outline" size="sm" onClick={pdf} data-testid="esign-confirm-preview-pdf"><Eye className="mr-2 h-4 w-4" />Preview PDF</Button>
          </div>)}
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="esign-confirm-cancel">Cancel</Button>
          <Button disabled={!p || busy} onClick={send} data-testid="esign-confirm-send">{busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Send className="mr-2 h-4 w-4" />}Send for signature</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
